<template>
  <app-modal name="create-rule-modal" :click-to-close="false" :submit-on-enter="false" :title="title" @before-open="beforeOpen"  width="40%" hide-footer>
    <p class="field-desc">
      {{$t('report.reportDesc')}}
    </p>
    <rule-form ref="form" :invoice="invoice"  :form-data="formData" @submit="onSubmit"></rule-form>
    <div class="row">
      <div class="col-12 text-right">
        <b-form-checkbox style="display: inline-block; margin-right: 8px; font-size: .9rem"  name="run-rule" v-model="execRule">
          {{$t('report.runReportNow')}}
        </b-form-checkbox>

        <button @click="onClickClose" class="btn btn-outline-secondary btn-sm">
          {{$t('app.close')}}
        </button>

        <app-btn-submit
          :is-submitting="isLoading"
          :css="'btn btn-primary btn-sm ml-2'"
          :text="$t('report.createReport')"
          @on-click="onClickSave()"
        />
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppBtnSubmit from '@/components/app-button';
import RuleForm from '@/portal-components/rule/rule-form';
import RuleProxy from '@/store/proxies/rule-proxy';
import { INVOICE_RULES } from '@/app-constant';

export default {
  name: 'CreateRuleModal',
  components: {
    AppBtnSubmit,
    RuleForm,
    AppModal,
  },
  data() {
    return {
      title: this.$t('report.createReport'),
      isLoading: false,
      formData: {},
      invoice: {},
      execRule: true,
    };
  },
  methods: {
    onSubmit(form) {
      let promise;
      const proxy = new RuleProxy();
      const payload = this.parseFormDataToPayload(form.formData);
      this.isLoading = true;
      // eslint-disable-next-line prefer-const
      promise = form.formData.id ? proxy.updateRule(payload) : proxy.createRule(payload);
      promise.then((response) => {
        this.$bus.emit('update-rule-success', {
          id: response.id,
          ...response.structure,
        });
        if (this.execRule) {
          new RuleProxy().execRule(response.id);
        }
        this.$bus.emit('on-unselect-items');
        this.$bus.emit('on-save-rule');
        this.$modal.hide('create-rule-modal', { isOk: true });
      }).finally(() => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      });
    },
    parseFormDataToPayload(formData) {
      const payload = {
        name: formData.name,
        structure: {
          ...formData,
        },
      };
      delete payload.structure.id;
      if (formData.id) {
        payload.id = formData.id;
      }
      payload.structure.conditions.forEach((c) => {
        if (c.key === 'RULE_AMOUNT_OF_DEBT_DAYS') {
          c.value = parseInt(c.value, 0);
        }
      });
      return payload;
    },
    onClickClose() {
      this.$modal.hide('create-rule-modal', { isOk: false });
    },
    onClickSave() {
      this.$refs.form.submit();
    },
    beforeOpen(params) {
      if (params.model.id) {
        this.title = this.$t('report.updateReport');
        this.formData = {
          ...params.model,
        };
      } else {
        this.title = this.$t('report.createReport');
        this.invoice = params.invoice;
        const name = this.invoice ? `${this.$t('report.report')} - ${this.invoice.invoice_number} - ${this.invoice.kind_of ? this.invoice.buyer_name : this.invoice.seller_name}` : null;
        const conditions = this.invoice ? [
          {
            key: this.invoice.kind_of ? INVOICE_RULES.RULE_BUYER : INVOICE_RULES.RULE_SELLER,
            value: this.invoice.kind_of ? this.invoice.buyer_name : this.invoice.seller_name,
          },
          { key: INVOICE_RULES.RULE_VAT,
            value: 10,
          },
        ] : [];

        this.formData = {
          name,
          conditions,
          target: null,
          tags: [],
        };
        if (this.invoice && this.invoice.content) {
          this.formData.conditions.push(
            { key: INVOICE_RULES.RULE_CONTENT,
              value: this.invoice.content,
            });
        }
      }
    },
  },
};
</script>
<style>
.rule-chk {
  display: inline-block;
  font-size: .8rem;
  margin-right: 6px;
}
.rule-chk label {
  padding: 4px 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/rule/create-rule-modal.vue